import { getElevenLabsConnectionConfigs } from "./utils"	
import store from "../store"
class ElevenLabsTextToSpeech {	
    constructor() {	
        this.websocket = null	
        this.onMessageCallback = null	
        this.onCloseCallback = null	
        this.onErrorCallback = null	
    }	
    init({onMessageCallback, onMessageCompleteCallback, onCloseCallback}) {	
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {	
            return	
        }	
        const { voice_id, model_id, stability, speed, similarity_boost, style, apply_text_normalization } = getElevenLabsConnectionConfigs()	
        const uri = `wss://api.elevenlabs.io/v1/text-to-speech/${voice_id}/stream-input?model_id=${model_id}&inactivity_timeout=180&apply_text_normalization=${apply_text_normalization}`	
        const ttsToken = store.state.ttsToken
        this.websocket = new WebSocket(uri)	
        this.websocket.onopen = () => {	
            this.websocket.send(	
                JSON.stringify({	
                    text: ' ',	
                    xi_api_key: ttsToken,	
                    voice_settings : {	
                        stability,	
                        speed,	
                        similarity_boost,	
                        style	
                    }	
                })	
            )	
        }	
        this.websocket.onmessage = (event) => {	
            onMessageCallback(event.data)	
            onMessageCompleteCallback(event.data)	
        }	
        this.websocket.onerror = (error) => {	
            onCloseCallback(error)	
        }	
    }	
    sendMessage(message) {	
        const { stability, speed, similarity_boost, style } = getElevenLabsConnectionConfigs()	
        if (this.websocket && this.websocket.readyState === WebSocket.OPEN) {	
            this.websocket.send(JSON.stringify({ 	
                text: message,	
                flush: true,	
                voice_settings : {	
                    stability,	
                    speed,	
                    similarity_boost,	
                    style	
                }	
            }))	
        }	
    }	
    closeConnection() {	
        if (this.websocket) {	
            this.websocket.close()	
        }	
    }	
}	

export default new ElevenLabsTextToSpeech()	
